module.exports = __webpack_public_path__ + "img/img-risk-sec-03-01.png";